export default __webpack_public_path__ + "static/media/shields.46307bd2.svg";